import React from "react";
import Button from "react-bootstrap/Button";
import {authCheck} from "../common/utils"
import {renderAuthPopup} from "../actionCreators/pdpAC"
import {useDispatch} from "react-redux"

const FooterLink = ({link}) => {
    const dispatch = useDispatch()

    const setAuthSession = () => {
        if (link.id) {
            sessionStorage.setItem(link.id, "1");
        }
    }

    if (!authCheck() && link.require_auth) {
        return (
            <li>
                <Button
                    className="footer-nav-container__link"
                    variant="clean"
                    onClick={() => dispatch(renderAuthPopup('signup', setAuthSession))}
                >
                    {link.label}
                </Button>
            </li>
        )
    }

    return (
        <li>
            <a className="footer-nav-container__link"
               href={link.url}
               data-type={link.type}
               target={link.target ? link.target : "_self"}
            >
                {link.label}
            </a>
        </li>
    )
}

export default FooterLink;